import type { GTMUserDataSource } from '../../core/user';
import type { GTMEventName, GTMOrderType } from '../../types';

export const OTT_CHECKOUT_EVENTS = {
    beginCheckout: 'begin_checkout',
} as const satisfies Record<string, GTMEventName>;

export const TV_ORDERING_CHECKOUT_EVENTS = {
    acceptTermsAndConditions: 'accept_terms_and_conditions',
    addClientInfo: 'add_client_info',
    addShippingInfo: 'add_shipping_info',
    beginCheckout: 'begin_checkout',
    cancelSignDocument: 'cancel_sign_document',
    purchase: 'purchase',
    signDocument: 'sign_document',
} as const satisfies Record<string, GTMEventName>;

export type OTTPlanPricing = {
    old?: string | number;
    regular?: string | number;
};

export type OTTPlanSource = {
    id?: string;
    name?: string;
    planOptionName?: string;
    netflixVariant?: string;
    pricing?: OTTPlanPricing;
    progressivePricing?: {
        eventualPrice?: {
            price?: string | number;
        };
    };
};

export type OTTPlanEventData = {
    userData?: GTMUserDataSource | null;
    plans: OTTPlanSource[];
};

export type OTTPlanEventInput = {
    source: 'ottPlans';
    data: OTTPlanEventData;
};

export type OTTPlanCheckoutAction = keyof typeof OTT_CHECKOUT_EVENTS;

export type OTTPlanCheckoutEventData = OTTPlanEventData & {
    action: OTTPlanCheckoutAction;
};

export type OTTPlanCheckoutInput = {
    source: 'ottPlans';
    data: OTTPlanCheckoutEventData;
};

export type TVOrderingEventData = {
    userData?: GTMUserDataSource | null;
    planName?: string;
    itemName?: string;
    originalPrice?: number;
    price?: number;
    commitmentPeriod?: number;
    transactionId?: string;
    orderType?: GTMOrderType | string;
    itemVariant?: string;
};

export type TVOrderingEventInput = {
    source: 'tvOrdering';
    data: TVOrderingEventData;
};

export type TVOrderingCheckoutAction = keyof typeof TV_ORDERING_CHECKOUT_EVENTS;

export type TVOrderingCheckoutEventName = (typeof TV_ORDERING_CHECKOUT_EVENTS)[TVOrderingCheckoutAction];

export type TVOrderingCheckoutEventData = TVOrderingEventData & {
    action: TVOrderingCheckoutAction;
};

export type TVOrderingCheckoutInput = {
    source: 'tvOrdering';
    data: TVOrderingCheckoutEventData;
};
